<p-dialog
	[(visible)]="visible"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[dismissableMask]="true"
	[style]="{ width: '70vw' }"
	[breakpoints]="{ '960px': '95vw' }"
	(onHide)="onHide()"
>
	<ng-template pTemplate="header">
		<div>
			<div class="font-semibold">{{ photo?.file_name }}</div>
			<div class="text-sm text-500" *ngIf="photo">
				<span *ngIf="photo.item_detail_id">Asset {{ photo.item_detail_id }} · </span>
				captured {{ photo.captured_at | date: 'short' }}
			</div>
		</div>
	</ng-template>
	<app-document-preview [document]="previewDocument" [previewUrl]="photoUrl" (download)="download()" />
</p-dialog>
